import { Controller } from "@hotwired/stimulus";

const MAX_ROWS = 30;

export default class ReactionRolesAdminController extends Controller {
  static targets = ["list", "row", "json"];
  static values = {
    placeholderChannel: String,
    placeholderMessage: String,
    placeholderEmoji: String,
    placeholderRole: String,
    ariaRemove: String,
  };

  connect() {
    this.#serialize();
  }

  addRow() {
    if (this.rowTargets.length >= MAX_ROWS) return;

    const row = document.createElement("div");
    row.className = "flex items-center gap-2 mb-2";
    row.dataset.reactionRolesAdminTarget = "row";
    row.innerHTML = `
      <input type="text" class="input input-bordered input-xs w-32 font-mono"
             data-field="channel_id"
             data-action="input->reaction-roles-admin#onChange">
      <input type="text" class="input input-bordered input-xs w-36 font-mono"
             data-field="message_id"
             data-action="input->reaction-roles-admin#onChange">
      <input type="text" class="input input-bordered input-xs w-20"
             data-field="emoji"
             data-action="input->reaction-roles-admin#onChange">
      <input type="text" class="input input-bordered input-xs w-32 font-mono"
             data-field="role_id"
             data-action="input->reaction-roles-admin#onChange">
      <button type="button"
              class="btn btn-ghost btn-xs btn-square text-error/70 hover:text-error shrink-0"
              data-action="click->reaction-roles-admin#removeRow">
        <i class="fa-solid fa-trash-can"></i>
      </button>
    `;
    const [channelInput, messageInput, emojiInput, roleInput] = row.querySelectorAll("input");
    channelInput.placeholder = this.placeholderChannelValue;
    messageInput.placeholder = this.placeholderMessageValue;
    emojiInput.placeholder = this.placeholderEmojiValue;
    roleInput.placeholder = this.placeholderRoleValue;
    row.querySelector("button").setAttribute("aria-label", this.ariaRemoveValue);
    this.listTarget.appendChild(row);
    channelInput.focus();
    this.#serialize();
  }

  removeRow(event) {
    event.currentTarget.closest("[data-reaction-roles-admin-target='row']")?.remove();
    this.#serialize();
  }

  onChange() {
    this.#serialize();
  }

  #rowData(row) {
    const v = (f) => row.querySelector(`[data-field='${f}']`)?.value?.trim() || "";
    return {
      channel_id: v("channel_id"),
      message_id: v("message_id"),
      emoji: v("emoji"),
      role_id: v("role_id"),
    };
  }

  #serialize() {
    const entries = this.rowTargets
      .map((row) => this.#rowData(row))
      .filter((e) => e.message_id || e.role_id);

    if (this.hasJsonTarget) {
      this.jsonTarget.value = JSON.stringify(entries);
    }
  }
}
